import SplitTable from "./SplitTable";

export default function Features(props) {
  let data = [];
  if (props.estatedProperty.scraper.unit_features) {
    data = props.estatedProperty.scraper.unit_features.filter((_) => _);
  }
  return <SplitTable data={data} label="Features" />;
}
